function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.07 31.25l-3.94 3.94V35a20.89 20.89 0 0135.66-14.77L54 16A26.88 26.88 0 008.13 34.87l-3.62-3.62-4.24 4.24 8.9 8.9a3 3 0 004.24 0l8.9-8.9zm51.66 3.26l-8.9-8.9a3.08 3.08 0 00-4.24 0l-8.9 8.9 4.24 4.24 4-4V35a20.89 20.89 0 01-35.69 14.77L16 54a26.88 26.88 0 0045.9-18.84l3.59 3.59z",
  fill: "#dce1ec"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.13 45.19L25.89 41 32 34.84V20.78h6v15.31a3 3 0 01-.88 2.12z",
  fill: "#23c386"
});

function SvgAvailability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MCA3MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNkY2UxZWN9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTguMDcgMzEuMjVsLTMuOTQgMy45NFYzNWEyMC44OSAyMC44OSAwIDAxMzUuNjYtMTQuNzdMNTQgMTZBMjYuODggMjYuODggMCAwMDguMTMgMzQuODdsLTMuNjItMy42Mi00LjI0IDQuMjQgOC45IDguOWEzIDMgMCAwMDQuMjQgMGw4LjktOC45ek02OS43MyAzNC41MWwtOC45LTguOWEzLjA4IDMuMDggMCAwMC00LjI0IDBsLTguOSA4LjkgNC4yNCA0LjI0IDQtNFYzNWEyMC44OSAyMC44OSAwIDAxLTM1LjY5IDE0Ljc3TDE2IDU0YTI2Ljg4IDI2Ljg4IDAgMDA0NS45LTE4Ljg0bDMuNTkgMy41OXoiLz48cGF0aCBkPSJNMzAuMTMgNDUuMTlMMjUuODkgNDEgMzIgMzQuODRWMjAuNzhoNnYxNS4zMWEzIDMgMCAwMS0uODggMi4xMnoiIGZpbGw9IiMyM2MzODYiLz48L3N2Zz4=";
export { SvgAvailability as ReactComponent };